var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFsLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  d: "M40.815 25.11H30.664v-6.382H48.5v16.264l-.297.342c-3.423 3.958-8.72 6.166-14.957 6.166-4.11 0-8.544-1.291-11.944-4.374-3.388-3.072-5.802-7.972-5.802-15.299 0-5.823 1.843-10.65 5.018-14.017 3.172-3.365 7.71-5.31 13.178-5.31 7.04 0 10.924 2.421 13.53 4.527l.002.001.925.742-4.064 5.342-1.019-.774c-2.776-2.11-5.772-3.094-9.401-3.094-3.303 0-5.986 1.168-7.835 3.35-1.84 2.17-2.806 5.29-2.806 9.114 0 3.997.946 7.214 2.783 9.44 1.848 2.24 4.549 3.416 7.913 3.416 3.354 0 5.931-1.203 7.42-2.505l.17-.15v-6.798h-.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M16 51h32v10H16V51z"
})));
export default SvgFsLight;